// Stabile Farbe je Spieler für alle Charts.
// Vergabe alphabetisch nach Name, damit ein Spieler in jedem Chart und
// jeder Saison dieselbe Farbe behält – unabhängig vom Tabellenplatz.
// Der eingeloggte Spieler bekommt immer HIGHLIGHT_COLOR.

// Kräftige, mittelhelle Töne mit mindestens 3:1 Kontrast auf Weiß.
export const SPIELER_FARBEN = [
  '#1E88E5', // Blau
  '#E53935', // Rot
  '#43A047', // Grün
  '#EF6C00', // Orange
  '#8E24AA', // Lila
  '#00897B', // Türkis
  '#B8860B', // Gold
  '#D81B60', // Pink
  '#3949AB', // Indigo
  '#689F38', // Hellgrün
  '#039BE5', // Hellblau
  '#6D4C41', // Braun
  '#5E35B1', // Violett
  '#C0392B'  // Ziegelrot
];

export const HIGHLIGHT_COLOR = '#3f3f3f';
export const VERGLEICH_COLOR = '#FF1493';
export const DURCHSCHNITT_COLOR = '#b0b0b0';

// Ab dem 15. Spieler: Farben per Goldenem Winkel erzeugen
const generierteFarbe = (i) => `hsl(${Math.round((i * 137.508) % 360)}, 65%, 38%)`;

export function farbenJeUserId(spieler) {
  const map = {};
  [...spieler]
    .sort((a, b) => (a.username || '').localeCompare(b.username || '', 'de', { sensitivity: 'base' }))
    .forEach((s, i) => {
      map[s.userId] = i < SPIELER_FARBEN.length ? SPIELER_FARBEN[i] : generierteFarbe(i);
    });
  return map;
}

export function spielerFarbe(farben, userId, currentUid) {
  if (userId === currentUid) return HIGHLIGHT_COLOR;
  return farben[userId] || SPIELER_FARBEN[0];
}
